export default {
  handlerWidth: 50,
  markWidth: 50,
  maxYears: 5,
};
